import { notifications } from '@mantine/notifications';

export const toasts = {
  loadingToast: {
    loading: (id: string, message?: string) => {
      notifications.hide(id);
      notifications.show({
        id: id,
        loading: true,
        title: 'Updating...',
        message: message || 'You cannot close this yet.',
        autoClose: false,
        withCloseButton: false,
      });
    },
    success: (id: string, message?: string) => {
      notifications.update({
        id: id,
        loading: false,
        color: 'teal',
        title: 'Success!',
        message: message || 'Your data has been updated.',
        autoClose: 5000,
      });
    },
    error: (id: string, message?: string) => {
      notifications.update({
        id: id,
        loading: false,
        color: 'red',
        title: 'Error!',
        message: message || 'There was an error updating your data.',
        autoClose: 5000,
      });
    },
  },
};
